 import React, { useState, useEffect } from "react";
import Select from "react-select";
import api from "../api/api"; // Make sure path is correct

export default function VendorUsers() {
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [users, setUsers] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;
  const [newUser, setNewUser] = useState({
    supplierName: "",
    username: "",
    password: "",
    vcode: "",
    vid: 0,
    email: "",
    mobileNo: "",
    active: 1,
    usrid: 0,
  });

  // Load vendors and users
  useEffect(() => {
    fetchVendors();
    fetchUsers();
  }, []);

  // Fetch vendor list
  const fetchVendors = async () => {
    try {
      const userName = sessionStorage.getItem("userName");
      const databaseKey = sessionStorage.getItem("databaseKey");

      const res = await api.GetSupplierList_API(userName, databaseKey);
      const vendors = res?.GetSupplierList_API_APIjs?.Table || [];
      setVendorList(vendors);

      const options = vendors.map((v) => ({
        value: v.Vid,
        label: v.Vname,
      }));

      setVendorOptions(options);
    } catch (err) {
      console.error("Error fetching vendors:", err);
    }
  };

  // Fetch existing users
  const fetchUsers = async () => {
    try {
      const userName = sessionStorage.getItem("userName");
      const databaseKey = sessionStorage.getItem("databaseKey");

      const res = await api.SupplierUserExplrList_API(userName, databaseKey);
      const result = res?.SupplierUserExplrList_API_APIjs?.Table || [];

      const mappedUsers = result.map((u, index) => ({
        slno: index + 1,
        vcode: u.Vcode || `VND${(index + 1).toString().padStart(3, "0")}`,
        supplierName: u.Vname || "",
        username: u.UserName || "",
        password: u.PassWord || "",
        email: u.Email || u.mail || "",
        mobileNo: u.MobileNo || u.Mobile || "",
        active: typeof u.Active !== "undefined" ? u.Active : 0,
        usrid: u.Usrid ?? u.UsrId ?? 0,
        vid: u.Vid ?? 0,
      }));

      setUsers(mappedUsers);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  // Open modal for new user
  const openNewModal = () => {
    setIsEditing(false);
    setNewUser({
      supplierName: "",
      username: "",
      password: "",
      vcode: "",
      vid: 0,
      email: "",
      mobileNo: "",
      active: 1,
      usrid: 0,
    });
    setShowModal(true);
  };

  // Open modal for edit
  const openEditModal = (index) => {
    const u = users[index];
    if (!u) return;

    setIsEditing(true);
    setEditingIndex(index);
    setNewUser({
      supplierName: u.supplierName || "",
      username: u.username || "",
      password: u.password || "",
      vcode: u.vcode || "",
      vid: u.vid ?? 0,
      email: u.email || "",
      mobileNo: u.mobileNo || "",
      active: typeof u.active !== "undefined" ? u.active : 1,
      usrid: u.usrid ?? 0,
    });
    setShowModal(true);
  };

  // ✅ Save user
  const handleSave = async () => {
    if (!newUser.supplierName || !newUser.username || !newUser.password) {
      alert("⚠️ Please fill all required fields!");
      return;
    }

    try {
      const usrid = isEditing ? newUser.usrid || 0 : 0;
      const vid = newUser.vid || 0;
      const vcode =
        newUser.vcode || `VND${(users.length + 1).toString().padStart(3, "0")}`;
      const email = newUser.email || "";
      const mobileNo = newUser.mobileNo || "";
      const active = newUser.active ?? 1;
      const userName = newUser.username;
      const passWord = newUser.password;
      const databaseKey = sessionStorage.getItem("databaseKey");
      const Sp_SqlAction = isEditing ? "UPDATE" : "INSERT";

      const res = await api.SaveSupplierUser_API(
        Sp_SqlAction,
        usrid,
        vid,
        vcode,
        newUser.supplierName,
        email,
        userName,
        passWord,
        active,
        mobileNo,
        databaseKey
      );

      // ✅ Handle response
      const message =
        res?.data?.[0]?.Error ||
        res?.data?.Message ||
        res?.Message ||
        res?.Error ||
        "";

      // ✅ Duplicate error message check
      if (
        message &&
        (message.toLowerCase().includes("duplicate") ||
          message.toLowerCase().includes("already exists") ||
          message.toLowerCase().includes("already"))
      ) {
        alert("❌ " + message);
        return; // stop further execution, keep popup open
      }

      // ✅ Success
      if (!message || /success/i.test(message)) {
        alert("✅ User saved successfully!");
        setShowModal(false);
        setIsEditing(false);
        setEditingIndex(null);
        setNewUser({
          supplierName: "",
          username: "",
          password: "",
          vcode: "",
          vid: 0,
          email: "",
          mobileNo: "",
          active: 1,
          usrid: 0,
        });
        await fetchUsers();
        window.location.reload(); // optional full refresh
      } else {
        alert("❌ Failed to save user: " + message);
      }
    } catch (err) {
      console.error("Error saving user:", err);
      alert("❌ Error saving user: " + (err?.message || err));
    }
  };

  // Handle vendor dropdown
  const handleVendorChange = (selectedOption) => {
    const selectedVendor = vendorList.find(
      (v) => v.Vid === selectedOption.value
    );
    if (selectedVendor) {
      setNewUser((prev) => ({
        ...prev,
        supplierName: selectedVendor.Vname || "",
        vid: selectedVendor.Vid,
        vcode: selectedVendor.VCode || selectedVendor.Vcode || "",
        email: selectedVendor.mail || "",
        mobileNo: selectedVendor.Mobile || "",
      }));
    }
  };

  // Search filter
  const filteredUsers = users.filter(
    (u) =>
      u.supplierName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      u.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      u.vcode?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination
  const totalPages = Math.ceil(filteredUsers.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedUsers = filteredUsers.slice(startIndex, startIndex + pageSize);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-full mx-auto bg-white rounded-lg shadow-lg">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-400 to-blue-500 text-white p-4 rounded-t-lg flex justify-between items-center">
          <h1 className="text-xl font-bold">Vendor Users</h1>
          <button
            onClick={openNewModal}
            className="bg-white/20 hover:bg-white/30 text-white px-3 py-2 rounded-lg font-semibold flex items-center space-x-1 transition-all duration-200"
            title="Add New User"
          >
            <span>➕</span>
            <span>New</span>
          </button>
        </div>

        {/* Search in Header */}
        <div className="p-4 bg-gradient-to-r from-slate-50 to-slate-100 border-b-2 border-slate-200">
          <input
            type="text"
            placeholder="🔍 Search Vendor Users..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-3 py-2 border border-slate-300 rounded focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>

        {/* Table */}
        <div className="p-6">
          <div className="overflow-x-auto shadow-2xl rounded-2xl">
            <div className="max-h-[500px] overflow-y-auto">
              <table className="min-w-full bg-white border-collapse">
                <thead className="bg-gradient-to-r from-slate-700 to-slate-800 sticky top-0 z-10">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-slate-600">#</th>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-slate-600">Vcode</th>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-slate-600">Supplier Name</th>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-slate-600">User Name</th>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-slate-600">Password</th>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-slate-600">Active</th>
                    <th className="px-4 py-3 text-left text-sm font-bold text-white">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedUsers.length > 0 ? (
                    paginatedUsers.map((user, index) => (
                      <tr key={user.slno} className={`transition-all duration-200 border-b border-slate-200 ${
                        index % 2 === 0
                          ? 'bg-white hover:bg-slate-100'
                          : 'bg-slate-50 hover:bg-slate-100'
                      }`}>
                        <td className="px-4 py-3 text-sm font-semibold text-slate-800 border-r border-slate-200">{startIndex + index + 1}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 border-r border-slate-200 font-medium">{user.vcode}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 border-r border-slate-200">{user.supplierName}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 border-r border-slate-200">{user.username}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 border-r border-slate-200">{user.password}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 border-r border-slate-200">{user.active === 1 ? "✅ Active" : "❌ Inactive"}</td>
                        <td className="px-4 py-3 text-center">
                          <button
                            onClick={() => openEditModal(startIndex + index)}
                            className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-3 py-1 rounded-lg font-semibold flex items-center space-x-1 transition-all duration-200 shadow-sm hover:shadow-md"
                          >
                            <span>✏️</span>
                            <span>Edit</span>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="px-6 py-12 text-center text-slate-500 bg-slate-100">
                        <div className="flex flex-col items-center space-y-2">
                          <span className="text-4xl">📭</span>
                          <span>No matching records found</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="flex justify-between items-center mt-8 px-4">
            <div className="flex items-center space-x-3">
              <button
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
                className={`px-5 py-3 rounded-xl font-bold transition-all duration-200 flex items-center space-x-2 ${
                  currentPage === 1
                    ? 'bg-slate-300 text-slate-500 cursor-not-allowed'
                    : 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white shadow-lg hover:shadow-xl transform hover:scale-105'
                }`}
              >
                <span className="text-lg">⬅️</span>
                <span>Previous</span>
              </button>

              <div className="flex items-center space-x-2">
                <span className="text-slate-600 font-semibold">Page</span>
                <span className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-2 rounded-xl font-bold shadow-md">
                  {currentPage} of {totalPages}
                </span>
              </div>

              <button
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`px-5 py-3 rounded-xl font-bold transition-all duration-200 flex items-center space-x-2 ${
                  currentPage === totalPages
                    ? 'bg-slate-300 text-slate-500 cursor-not-allowed'
                    : 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white shadow-lg hover:shadow-xl transform hover:scale-105'
                }`}
              >
                <span>Next</span>
                <span className="text-lg">➡️</span>
              </button>
            </div>

            <div className="text-sm text-slate-500 font-medium">
              Showing {startIndex + 1}-{Math.min(startIndex + pageSize, filteredUsers.length)} of {filteredUsers.length} records
            </div>
          </div>
        </div>

        {/* Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-2xl p-5 w-[400px]">
              <h3 className="text-base font-semibold text-gray-700 mb-3 text-center">
                {isEditing ? "Edit Vendor User" : "Add Vendor User"}
              </h3>

              <div className="space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Name</label>
                  <Select
                    options={vendorOptions}
                    value={vendorOptions.find(
                      (option) => option.value === (newUser.vid ?? 0)
                    )}
                    onChange={handleVendorChange}
                    placeholder="-- Select Vendor --"
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "35px",
                        fontSize: "14px",
                      }),
                    }}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">User Name</label>
                  <input
                    type="text"
                    value={newUser.username}
                    onChange={(e) =>
                      setNewUser({ ...newUser, username: e.target.value })
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                  <input
                    type="password"
                    value={newUser.password}
                    onChange={(e) =>
                      setNewUser({ ...newUser, password: e.target.value })
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
                  />
                </div>

                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="active"
                    checked={newUser.active === 1}
                    onChange={(e) =>
                      setNewUser({ ...newUser, active: e.target.checked ? 1 : 0 })
                    }
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label htmlFor="active" className="ml-2 block text-sm text-gray-900">Active</label>
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => {
                    setShowModal(false);
                    setIsEditing(false);
                    setEditingIndex(null);
                    setNewUser({
                      supplierName: "",
                      username: "",
                      password: "",
                      vcode: "",
                      vid: 0,
                      email: "",
                      mobileNo: "",
                      active: 1,
                      usrid: 0,
                    });
                  }}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSave}
                  className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                >
                  {isEditing ? "Save Changes" : "Save"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
